import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Bell, BellOff, BellRing } from "lucide-react";
import { Button } from "../ui/button";
import { useAuth } from "../../App";
import { pushSupported, subscribePush } from "../../lib/push";

// Admin header control: lets Steve subscribe his phone to push (approvals, feedback, etc.)
const AdminPushButton = () => {
  const { token } = useAuth();
  const [state, setState] = useState("unsupported"); // unsupported | default | granted | denied
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pushSupported() || !token) return;
    setState(Notification.permission);
    if (Notification.permission === "granted") subscribePush(token).catch(() => {});
  }, [token]);

  if (state === "unsupported") return null;

  const enable = async () => {
    setBusy(true);
    try {
      const permission = await Notification.requestPermission();
      setState(permission);
      if (permission !== "granted") {
        toast.error("Notifications are blocked for this site — allow them in your browser settings");
        return;
      }
      await subscribePush(token);
      toast.success("Alerts on — you'll get a ping when guests propose events 🔔");
    } catch {
      toast.error("Couldn't enable notifications");
    } finally {
      setBusy(false);
    }
  };

  if (state === "granted") {
    return (
      <span className="p-2 text-[#8C9A7C]" title="Push alerts are on for this device" data-testid="admin-push-on">
        <BellRing className="w-4 h-4" />
      </span>
    );
  }

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={enable}
      disabled={busy}
      className={`rounded-full text-xs sm:text-sm border-[#C85A38]/40 text-[#C85A38] hover:bg-[#C85A38]/10 ${state === "denied" ? "opacity-60" : ""}`}
      title={state === "denied" ? "Blocked — allow notifications in browser settings" : "Get a ping on this phone when guests propose events"}
      data-testid="admin-push-enable-btn"
    >
      {state === "denied" ? <BellOff className="w-4 h-4 sm:mr-1.5" /> : <Bell className="w-4 h-4 sm:mr-1.5" />}
      <span className="hidden sm:inline">{busy ? "Enabling..." : "Enable alerts"}</span>
    </Button>
  );
};

export default AdminPushButton;
